<template>
  <header class="inner-banner">
    <div class="container">
      <div class="row">
        <div class="inner-wrapper">
          <div class="col-md-12">
            <div class="container">
              <div class="card card-container coach-register-form">
                <a href="/">
                  <img src="images/logo.png" alt="Logo" class="text-center" />
                </a>
                <div class="d-flex-column-center">
                  <h2 class="form-header-text">
                    NEW CLUB VERIFICATION REQUEST FORM
                  </h2>
                  <span class="required-field-text"
                    >Fields marked with asterisk sign(*) are required
                    fields</span
                  >
                </div>

                <div class="club-verifcation-form">
                  <div class="club-info-text-wrapper">
                    <span class="club-info-text">Club Info</span>
                  </div>
                  <a-form
                    class="padding-top-1"
                    layout="horizontal"
                    :form="form"
                    @submit="handleSubmit"
                  >
                    <a-row :gutter="16">
                      <a-col :sm="24">
                        <a-form-item>
                          <a-input
                            ref="clubName"
                            v-decorator="[
                              'clubName',
                              {
                                rules: [
                                  {
                                    required: true,
                                    message: 'Please input Club name!'
                                  }
                                ]
                              }
                            ]"
                            placeholder="Club Name *"
                          >
                            <a-icon
                              slot="prefix"
                              type="home"
                              style="color: rgba(0,0,0,.35)"
                            />
                          </a-input>
                        </a-form-item>
                      </a-col>
                      <a-col :sm="24">
                        <a-form-item>
                          <a-input
                            ref="address1"
                            v-decorator="[
                              'address1',
                              {
                                rules: [
                                  {
                                    required: false,
                                    message: 'Please input Club address!'
                                  }
                                ]
                              }
                            ]"
                            placeholder="Club Address"
                          >
                            <a-icon
                              slot="prefix"
                              type="pushpin"
                              style="color: rgba(0,0,0,.35)"
                          /></a-input>
                        </a-form-item>
                      </a-col>
                      <a-col :sm="24" :md="12">
                        <a-form-item>
                          <a-input
                            ref="city"
                            v-decorator="[
                              'city',
                              {
                                rules: [
                                  {
                                    required: true,
                                    message: 'Please input Club city!'
                                  }
                                ]
                              }
                            ]"
                            placeholder="City *"
                          >
                            <a-icon
                              slot="prefix"
                              type="shop"
                              style="color: rgba(0,0,0,.35)"
                          /></a-input>
                        </a-form-item>
                      </a-col>
                      <a-col :sm="24" :md="12">
                        <a-form-item>
                          <a-select
                            ref="state"
                            show-search
                            option-filter-prop="children"
                            v-decorator="[
                              'state',
                              {
                                rules: [
                                  {
                                    required: true,
                                    message: 'Select State!'
                                  }
                                ]
                              }
                            ]"
                            placeholder="Select State *"
                          >
                            <a-select-option
                              v-for="state in stateList"
                              :key="state._id"
                              :value="state._id"
                              >{{ state.name }}</a-select-option
                            >
                          </a-select>
                        </a-form-item>
                      </a-col>
                      <a-col :sm="24" :md="12">
                        <a-form-item>
                          <a-input
                            ref="clubPhone"
                            v-decorator="[
                              'clubPhone',
                              {
                                rules: [
                                  {
                                    required: false,
                                    message: 'Please input Club number!'
                                  }
                                ]
                              }
                            ]"
                            placeholder="Club Phone Number"
                          >
                            <a-icon
                              slot="prefix"
                              type="phone"
                              style="color: rgba(0,0,0,.35)"
                            />
                          </a-input>
                        </a-form-item>
                      </a-col>
                      <a-col :sm="24" :md="12">
                        <a-form-item>
                          <a-input
                            ref="url"
                            v-decorator="[
                              'url',
                              {
                                rules: [
                                  {
                                    required: false,
                                    message: 'Please input Club URL!'
                                  }
                                ]
                              }
                            ]"
                            placeholder="Club URL"
                          >
                            <a-icon
                              slot="prefix"
                              type="global"
                              style="color: rgba(0,0,0,.35)"
                          /></a-input> </a-form-item
                      ></a-col>
                      <a-col :sm="24" :md="12">
                        <a-form-item>
                          <a-select
                            ref="ageGroup"
                            show-search
                            option-filter-prop="children"
                            v-decorator="[
                              'ageGroup',
                              {
                                rules: [
                                  {
                                    required: true,
                                    message: 'Please Select Age Group!'
                                  }
                                ]
                              }
                            ]"
                            placeholder="Select Age Group *"
                          >
                            <a-select-option
                              v-for="age in ageGroups"
                              :key="age.name"
                              :value="age.Id"
                              >{{ age.name }}</a-select-option
                            >
                          </a-select>
                        </a-form-item>
                      </a-col>
                    </a-row>
                    <a-row :gutter="16">
                      <div>
                        <span class="info-text">COACH INFO</span>
                      </div>
                      <a-col :sm="24">
                        <a-form-item class="padding-top-1">
                          <a-input
                            ref="coachName"
                            v-decorator="[
                              'coachName',
                              {
                                rules: [
                                  {
                                    required: true,
                                    message: 'Please input coach name!'
                                  }
                                ]
                              }
                            ]"
                            placeholder="Coach Name *"
                          >
                            <a-icon
                              slot="prefix"
                              type="user"
                              style="color: rgba(0,0,0,.35)"
                            />
                          </a-input>
                        </a-form-item>
                      </a-col>
                      <a-col :sm="24" :md="12">
                        <a-form-item>
                          <a-input
                            ref="position"
                            v-decorator="[
                              'position',
                              {
                                rules: [
                                  {
                                    required: true,
                                    message: 'Please input Position'
                                  }
                                ]
                              }
                            ]"
                            placeholder="Position *"
                          >
                            <a-icon
                              slot="prefix"
                              type="team"
                              style="color: rgba(0,0,0,.35)"
                          /></a-input>
                        </a-form-item>
                      </a-col>
                      <a-col :sm="24" :md="12">
                        <a-form-item>
                          <a-input
                            ref="email"
                            v-decorator="[
                              'email',
                              {
                                initialValue: $route.query.email,
                                rules: [
                                  {
                                    required: true,
                                    message: 'Please input Coach Email!'
                                  }
                                ]
                              }
                            ]"
                            placeholder="Coach Email *"
                          >
                            <a-icon
                              slot="prefix"
                              type="mail"
                              style="color: rgba(0,0,0,.35)"
                          /></a-input> </a-form-item
                      ></a-col>
                      <a-col :sm="24" :md="12">
                        <a-form-item>
                          <a-input
                            ref="coachPhone"
                            v-decorator="[
                              'coachPhone',
                              {
                                rules: [
                                  {
                                    required: true,
                                    message: 'Please input Coach number!'
                                  }
                                ]
                              }
                            ]"
                            placeholder="Coach Phone Number*"
                          >
                            <a-icon
                              slot="prefix"
                              type="phone"
                              style="color: rgba(0,0,0,.35)"
                            />
                          </a-input>
                        </a-form-item>
                      </a-col>
                    </a-row>
                    <p class="card-info-text">
                      Verification Card(USA Softball/ASA, USSSA, or Other) -
                      Image
                    </p>
                    <p class="description-text">
                      Note: To ensure the safety of all players using this
                      platform, all coaches need to show proof of a valid
                      coaching card issued by USA Softball ASA. USSSA or another
                      nationally recognized youth sports organization that
                      requires background checks for coaches
                    </p>
                    <BaseDragUpload
                      ref="fileUpload"
                      @file-upload="handleFileUpload"
                    />
                    <a-form-item>
                      <a-button
                        type="primary"
                        html-type="submit"
                        class="login-form-button next-button save-button"
                        :loading="loading"
                      >
                        Submit
                      </a-button>
                    </a-form-item>
                  </a-form>
                  <div class="d-flex-column">
                    <a
                      class="color-secondary margin-bottom-2 margin-t-1"
                      href="/login"
                      >Already Verified? Login</a
                    >
                    <a class="color-secondary" href="/">
                      Back To Top Notch Athletes</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { mapGetters } from "vuex";
import { RepositoryFactory } from "../../repositories/RepositoryFactory";
const TaxonomyRepository = RepositoryFactory.get("taxonomy");
const CLUB_STORE_KEY = "clubStore";
const SEARCH_STORE_KEY = "searchStore";

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

export default {
  name: "CollegeRegister",
  created() {
    TaxonomyRepository.getSortedTaxonomyValues("State").then(response => {
      this.stateList = response.data.taxonomy.values;
    });
  },
  data() {
    return {
      hasErrors,
      exceptionValues: ["North Carolina", "South Carolina"],
      form: this.$form.createForm(this),
      imageData: null,
      stateList: []
    };
  },
  async mounted() {
    await this.$store.dispatch(`${SEARCH_STORE_KEY}/getTaxonomy`, {
      storeKey: "ageGroups",
      loadingKey: "ageGroupsLoading",
      type: "Age Group"
    });
    this.$nextTick(() => {
      // To disabled submit button at the beginning.
      // this.form.validateFields();
    });
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters({
      clubNameExists: `${CLUB_STORE_KEY}/clubNameExists`,
      ageGroups: `${SEARCH_STORE_KEY}/ageGroups`
    })
  },
  methods: {
    handleFileUpload(data) {
      this.imageData = data;
    },
    // Only show error after a field is touched.
    handleError(val) {
      const { getFieldError, isFieldTouched } = this.form;
      return isFieldTouched(val) && getFieldError(val);
    },
    async handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (err) {
          this.$refs[Object.keys(err)[0]].focus();
        }
        if (!err) {
          this.$store.dispatch(`${CLUB_STORE_KEY}/checkClubName`, {
            clubName: values.clubName
          });
          if (this.clubNameExists) {
            this.$notification.error({
              message: "Error",
              description: "Club name already exists in the state."
            });
          } else {
            if (!this.imageData) {
              this.$notification.error({
                message: "Error",
                description: "Upload Verification Card"
              });
              return;
            }
            let clubForm = new FormData();
            clubForm.append("coachname", values.coachName);
            clubForm.append("email", values.email);
            clubForm.append("clubName", values.clubName);
            clubForm.append("ageGroup", values.ageGroup);
            clubForm.append("state", values.state);
            clubForm.append("clubPhone", values.clubPhone);
            clubForm.append("coachPhone", values.coachPhone);
            clubForm.append("address", values.address1);
            clubForm.append("position", values.position);
            clubForm.append("city", values.city);
            clubForm.append("url", values.url);
            clubForm.append("file", this.imageData);
            this.$emit("form-submit", clubForm);
          }
        }
      });
    },
    handleFormReset() {
      this.form.resetFields();
      // this.form.validateFields();
      this.$refs.fileUpload.removeSingle();
    }
  }
};
</script>

<style lang="scss" scoped>
.card {
  h2 {
    margin-bottom: 10px !important;
  }
}
.coach-register-form {
  max-width: 600px !important;
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
  .form-header-text {
    padding-bottom: 16px;
    font-size: 20px;
    color: #cc2f2a;
    text-align: center;
  }
  .club-verifcation-form {
    .club-info-text-wrapper {
      padding-top: 15px;
      margin-left: 2px;
      .club-info-text {
        text-transform: uppercase;
        font-weight: 600;
        font-size: 16px;
        color: black;
      }
    }
    .card-info-text {
      margin: 20px 0 10px !important;
    }
    .description-text {
      font-size: 12px;
      line-height: 20px;
    }
    .save-button {
      width: 100%;
      border-radius: 4px !important;
    }
    .coach-info-text {
      font-weight: 500;
      font-size: 16px;
      text-transform: uppercase;
    }
    .coach-data {
      height: 0;
      opacity: 0;
      transition: all 0.2s linear;
      &.active {
        height: 270px;
        opacity: 1;
      }
    }
  }
}
@media only screen and (max-width: 575px) {
  .coach-register-form {
    .form-header-text {
      padding: 15px 0 10px;
      margin-bottom: 0 !important;
      font-size: 14px;
    }
    .required-field-text {
      font-size: 12px;
    }
    .club-verifcation-form {
      .card-info-text {
        line-height: 20px;
        margin: 10px 0 5px !important;
      }
      .description-text {
        font-weight: normal;
        color: #737373;
      }
    }
  }
}
</style>
